import React, { useEffect, useRef } from "react";
import CalendarIcon from "../../assests/images/calendar-color-icon.png";
import { useData } from "../context/data/DataState";
import { getDatesInRange } from "../helpers/datearraybuilder";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { cn } from "../../lib/utils";

const DateTabs = () => {
  const {
    date,
    setdate,
    setformattedDate,
    communityId,
    seasonId,
    challengeId,
    data,
  } = useData();

  const scrollContainerRef = useRef(null);
  let dateobj = new Date();

  // Colors from original code
  const tabBkgColor = {
    disabled: "#b9b9b9",
    completed: "#87ff87",
    incomplete: "#ffa3a3",
    normal: "white",
  };

  const handleChange = (newValue) => {
    setdate(newValue);
    setformattedDate(new Date(newValue));
  };

  // Scroll to active tab on mount/change
  useEffect(() => {
    if (scrollContainerRef.current) {
      const activeTab = scrollContainerRef.current.querySelector('[data-state="active"]');
      if (activeTab) {
        activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }, [date]);

  if (!data || !data.community || !data.community[communityId]) return null;

  const dates = getDatesInRange(
    data.community[communityId]?.season[seasonId]?.challenge[challengeId]?.start_date,
    data.community[communityId]?.season[seasonId]?.challenge[challengeId]?.end_date
  );

  return (
    <div className="w-full">
      <Tabs value={date} onValueChange={handleChange} className="w-full">
        <TabsList
          ref={scrollContainerRef}
          className="w-full justify-start overflow-x-auto flex-nowrap bg-transparent p-0 h-[75px] gap-2 no-scrollbar pb-2"
        >
          {dates.map((item, index) => {
            const isFuture = item.dateObj > dateobj;
            const bgColor = isFuture ? tabBkgColor.disabled : tabBkgColor.completed;

            return (
              <TabsTrigger
                key={index}
                value={item.dateId}
                disabled={isFuture}
                className={cn(
                  "p-0 h-auto bg-transparent data-[state=active]:bg-transparent data-[state=active]:shadow-none border-0 rounded-none opacity-100 disabled:opacity-50 min-w-[60px] group",
                  "transition-transform active:scale-95"
                )}
              >
                <div className="relative text-center">
                  <img
                    src={CalendarIcon}
                    alt="date-tab"
                    style={{
                      width: "43px",
                      borderRadius: "5px",
                      backgroundColor: bgColor,
                    }}
                    className="mx-auto shadow-sm transition-all duration-200 group-data-[state=active]:ring-2 group-data-[state=active]:ring-offset-2 group-data-[state=active]:ring-black group-data-[state=active]:scale-110"
                  />

                  <div className="absolute top-[53%] left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold text-xl flex flex-col items-center justify-center leading-none w-full">
                    <div className="text-[10px] text-white font-normal mb-0.5 drop-shadow-md">{item.month}</div>
                    <div className="text-[18px] text-gray-900 pb-1">{item.date}</div>
                  </div>
                </div>
              </TabsTrigger>
            );
          })}
        </TabsList>
      </Tabs>
    </div>
  );
};

export default DateTabs;
